/* v8 ignore start */
/* eslint-disable no-bitwise */
export interface IHashable {
  hashCode: () => number;
}

export function hash(arg: any): number {
  if (typeof arg === "number") {
    return stringHash(arg.toString());
  } else if (typeof arg === "string") {
    return stringHash(arg);
  } else if (typeof arg === "undefined") {
    return 1534124234;
  } else if (typeof arg === "boolean") {
    return stringHash(arg.toString());
  } else if (typeof arg === "function") {
    return 4325431234;
  } else if (typeof arg === "object") {
    if (arg instanceof Date) {
      return stringHash((arg as Date).getTime().toString());
    } else if (arg === null) {
      return 2345174394;
    } else if (isHashable(arg)) {
      return arg.hashCode();
    } else {
      return hashObject(arg);
    }
  } else {
    // This is probably a Symbol, fallback to using toString()
    return stringHash(arg.toString());
  }
}

function isHashable(obj: any): obj is IHashable {
  return obj != null && typeof obj.hashCode === "function";
}

// cspell:ignore cyrb
const cyrb53 = (str: string, seed = 0) => {
  let h1 = 0xdeadbeef ^ seed,
    h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};

function stringHash(str: string): number {
  return cyrb53(str);
}

function hashObject(obj: {[key: string]: any}): number {
  let result = 0;
  for (const property in obj) {
    if (obj.hasOwnProperty.call(obj, property)) {
      result += stringHash(property + hash(obj[property]));
    }
  }

  return result;
}
/* v8 ignore stop */
